// The board's opening: one sentence about what this is, two honest counts,
// one search. Everything else on the page is the list.
import type { FormEvent } from "react";

type Props = {
  jobTitle: string;
  setJobTitle: (v: string) => void;
  location: string;
  setLocation: (v: string) => void;
  onSubmit: (e: FormEvent) => void;
  total?: number;
  new24h?: number;
};

const fmt = (n?: number) => (n ? n.toLocaleString("en-US") : null);

export default function BoardHero({ jobTitle, setJobTitle, location, setLocation, onSubmit, total, new24h }: Props) {
  return (
    <section className="bh-hero" aria-labelledby="bh-h1">
      <div className="container">
        <h1 id="bh-h1" className="bh-hero__h1">Find your next accounting or finance job.</h1>
        <p className="bh-hero__lede">
          {fmt(total) ? <><b>{fmt(total)}</b> open roles, read from employers&rsquo; own career pages.</> : "Open roles, read from employers’ own career pages."}
          {fmt(new24h) && <> <b>{fmt(new24h)}</b> new in the last 24 hours.</>}
        </p>
        <form role="search" className="bh-search" onSubmit={onSubmit}>
          <label className="bh-search__field">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>
            <span className="bh-sr">Role, skill or company</span>
            <input type="search" value={jobTitle} onChange={(e) => setJobTitle(e.target.value)} placeholder="Role, skill or company" autoComplete="off" enterKeyHint="search" />
          </label>
          <label className="bh-search__field bh-search__field--loc">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5a7 7 0 0114 0C19 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></svg>
            <span className="bh-sr">City or region</span>
            <input type="text" value={location} onChange={(e) => setLocation(e.target.value)} placeholder="City or region" autoComplete="off" enterKeyHint="search" />
          </label>
          <button type="submit" className="bh-search__go">Search</button>
        </form>
      </div>
    </section>
  );
}
